(function () {
  if (typeof window === 'undefined' || window.__tvCartHostProjectionInstalled) return;
  window.__tvCartHostProjectionInstalled = true;

  function renderCartBadge(projection) {
    if (!projection || typeof projection.item_count !== 'number') return;
    var bubble = document.querySelector('#cart-icon-bubble');
    if (!bubble) return;
    bubble.textContent = projection.item_count;
    if (projection.item_count === 0) {
      bubble.classList.add('hidden', 'hide');
      bubble.style.display = 'none';
      return;
    }
    bubble.classList.remove('hidden', 'hide');
    bubble.style.display = '';
  }

  window.renderCartBadge = renderCartBadge;

  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || !event.cartData) return;
      renderCartBadge(event.cartData);
    });
  }
})();
